/*
 * Splits one of our asset URLs into container and blob name. Handles both
 * the media proxy form (https://mixiply.com/media/{container}/{blob}) and
 * the older raw storage form (https://account.blob.core.windows.net/{container}/{blob}).
 */
export default function getBlobInfoFromUri(uri: string): {
    containerName: string;
    blobName: string;
} {
    const url = new URL(uri);
    const pathSegments = url.pathname
        .split('/')
        .filter(segment => segment.length > 0);

    if (pathSegments[0] === 'media') {
        pathSegments.shift();
    }

    const containerName = pathSegments[0];
    const blobName = decodeURIComponent(pathSegments.slice(1).join('/'));
    return {containerName, blobName};
}
